import BitCloutIcon from "../../images/Svg/checkProfle/BitClout.svg";
import DeSocialWorldIcon from "../../images/Svg/checkProfle/DeSocialWorld.svg";
import DiamondIcon from "../../images/Svg/checkProfle/Diamond.svg";
import stori from "../../images/Svg/checkProfle/stori.svg";

export const CheckProfileData = [
  {
    id: 1,
    icon: DeSocialWorldIcon,
    title: "DeSocialWorld",
    link: "https://desocialworld.com/u/",
  },
  {
    id: 2,
    icon: DiamondIcon,
    title: "Diamond",
    link: "https://diamondapp.com/u/",
  },
];
export const checkProfileData2 = [
  {
    id: 3,
    icon: stori,
    title: "Stori",
    link: "https://web.storiapp.co/profile?username=",
  },
  {
    id: 4,
    icon: BitCloutIcon,
    title: "BitClout",
    link: "https://bitclout.com/u/",
  },
];
